var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [_c("add-new-ip")],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [_c("blocked-ip-table")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }